import { ITime, TimeUnit, IDistance, DistanceUnit, Distance } from '..'
import { IPace, PaceType } from './pace'
import { Time } from './time'

// start of the speed IPace mappings
const getMilesPerHourSpeed = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.HOURS
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.MILES
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.SPEED
  }

  return pace
}

const getKilometersPerHourSpeed = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.HOURS
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.KILO_METERS
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.SPEED
  }

  return pace
}

const get100MetersPerMinuteSpeed = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.MINUTES
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.HECTA_METERS
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.SPEED
  }

  return pace
}

const get100YardsPerMinuteSpeed = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.MINUTES
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.HECTA_YARDS
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.SPEED
  }

  return pace
}

const getYardsPerSecondSpeed = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.SECONDS
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.YARDS
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.SPEED
  }

  return pace
}

const getFeetPerSecondSpeed = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.SECONDS
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.FEET
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.SPEED
  }

  return pace
}

const getMetersPerSecondSpeed = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.SECONDS
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.METERS
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.SPEED
  }

  return pace
}

// start of the pace IPace mappings
const getMinuteMilePace = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.MINUTES
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.MILES
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.PACE
  }

  return pace
}

const getMinuteKilometerPace = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.MINUTES
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.KILO_METERS
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.PACE
  }

  return pace
}

const getMin100YdPace = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.MINUTES
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.HECTA_YARDS
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.PACE
  }

  return pace
}

const getMin100MetersPace = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time: ITime = {
    timeInMillis: timeInMilliseconds,
    timeUnit: TimeUnit.MINUTES
  }

  const distance: IDistance = {
    distanceInMeters: distanceInMeters,
    distanceUnit: DistanceUnit.HECTA_METERS
  }

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.PACE
  }

  return pace
}

const getDefaultPace = (timeInMilliseconds: number, distanceInMeters: number): IPace => {

  const time = new Time()
  time.timeInMillis = timeInMilliseconds

  const distance = new Distance()
  distance.distanceInMeters = distanceInMeters

  const pace: IPace = {
    distance: distance,
    time: time,
    paceType: PaceType.NOTCALCULATED
  }

  return pace
}

// MilesPerHour = 'mph',
// KilometersPerHour = 'kph',
// HectaMeterPerMinute = '100m/min',
// HectaYardPerMinute = '100yd/min',
// MinutePerMile = 'min/mi',
// MinutePerKilometer = 'min/km',
// MinutePerHectaYard = 'min/100yd',
// MinutePerHectaMeter = 'min/100m'
// Our current systems stores min/mi, mph, kph, 100m/min, ect as the pace unit.
// This function converts that to a the IPace object.
export const convertToPace = (paceUnit: string, timeInMilliseconds: number, distanceInMeters: number): IPace => {

  // map the speed pace units
  if (paceUnit.toLowerCase() === 'mph' || paceUnit.toLowerCase() === 'mi/hr') {
    return getMilesPerHourSpeed(timeInMilliseconds, distanceInMeters)
  }

  if (paceUnit.toLowerCase() === 'kph' || paceUnit.toLowerCase() === 'km/hr') {
    return getKilometersPerHourSpeed(timeInMilliseconds, distanceInMeters)
  }

  if (paceUnit.toLowerCase() === '100m/min') {
    return get100MetersPerMinuteSpeed(timeInMilliseconds, distanceInMeters)
  }

  if (paceUnit.toLowerCase() === '100yd/min') {
    return get100YardsPerMinuteSpeed(timeInMilliseconds, distanceInMeters)
  }

  if (paceUnit.toLowerCase() === 'yd/s') {
    return getYardsPerSecondSpeed(timeInMilliseconds, distanceInMeters)
  }

  if (paceUnit.toLowerCase() === 'ft/s') {
    return getFeetPerSecondSpeed(timeInMilliseconds, distanceInMeters)
  }

  if (paceUnit.toLowerCase() === 'm/s') {
    return getMetersPerSecondSpeed(timeInMilliseconds, distanceInMeters)
  }

  // map the pace paceUnits
  if (paceUnit.toLowerCase() === 'min/mi') {
    return getMinuteMilePace(timeInMilliseconds, distanceInMeters)
  }

  if (paceUnit.toLowerCase() === 'min/km') {
    return getMinuteKilometerPace(timeInMilliseconds, distanceInMeters)
  }

  if (paceUnit.toLowerCase() === 'min/100m') {
    return getMin100MetersPace(timeInMilliseconds, distanceInMeters)
  }

  if (paceUnit.toLowerCase() === 'min/100yd') {
    return getMin100YdPace(timeInMilliseconds, distanceInMeters)
  }

  return getDefaultPace(timeInMilliseconds, distanceInMeters)
}